<template>
  <v-card color="borderInner" elevation="0" rounded="0" style="height: 100%; width: 100%;">
    <v-date-input
      ref="date"
      v-model="input.date"
      @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
      @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'date'); input.date = systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMShippingRanking/selectAllDate')?.CRMAgentPermissionValue == '1' ? Array.from({length: 60}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(59-i)); return d.toISOString().split('T')[0]; }) : Array.from({length: 45}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(44-i)); return d.toISOString().split('T')[0]; });" 
      prepend-inner-icon="mdi-calendar"
      :loading="loader.getSystemInformationData || loader.selectCRMWhatsappInvoiceFromCRMShippingRankingView"
      :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappInvoiceFromCRMShippingRankingView"
      :min="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMShippingRanking/selectAllDate')?.CRMAgentPermissionValue == '1' ? null : new Date(new Date().setDate(new Date().getDate() - 45)).toISOString().split('T')[0]"
      :max="new Date().toISOString().split('T')[0]"
      prepend-icon=""
      label="Filtrar por fecha"
      variant="outlined"
      density="compact"
      multiple="range"
      autocomplete="off"
      hide-details
      style="margin: 15px;"
    ></v-date-input>

    <div v-if="display.CRMShippingRankingInformation != null" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 400px; position: relative;">
      <apexchart
        type="donut" 
        height="400px" 
        width="100%"
        :options="display.CRMShippingRankingInformation.CRMWhatsappInvoiceCountChartOptions" 
        :series="display.CRMShippingRankingInformation.CRMWhatsappInvoiceCountChartSeries"
        class="hoverableText"
      />
    </div>
  </v-card>
</template>

<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import VueApexCharts from 'vue3-apexcharts'
  import { VDateInput } from 'vuetify/labs/VDateInput'

  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$localStorageFunctions'],

    components: 
    { 
      apexchart: VueApexCharts,
      VDateInput
    },

    data: () => 
    ({
      input: 
      {
        date: []
      },
      display: 
      {
        CRMShippingRankingInformation: null
      },
      navigation: 
      {
        CRMLocalityID: null
      },
      interval:
      {
        selectCRMWhatsappInvoiceFromCRMShippingRankingView: null
      },
      loader: 
      {
        getSystemInformationData: false,
        selectCRMWhatsappInvoiceFromCRMShippingRankingView: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: false
      },
    }),

    methods:
    {

      async selectCRMWhatsappInvoiceFromCRMShippingRankingView(newSearch){
        if (newSearch){
          this.display.CRMShippingRankingInformation = null;
          this.loader.selectCRMWhatsappInvoiceFromCRMShippingRankingView = true;
        }
        const selectCRMWhatsappInvoiceFromCRMShippingRankingViewRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMLocalityID': this.navigation.CRMLocalityID,
          'startDate': this.input.date.length > 0 ? this.input.date[0] : new Date(),
          'endDate': this.input.date.length > 0 ? this.input.date[this.input.date.length - 1] : new Date()
        };
        const selectCRMWhatsappInvoiceFromCRMShippingRankingViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappInvoice/functions/selectCRMWhatsappInvoiceFromCRMShippingRankingView', selectCRMWhatsappInvoiceFromCRMShippingRankingViewRequestQuery);
        if (selectCRMWhatsappInvoiceFromCRMShippingRankingViewResult.success){
          this.display.CRMShippingRankingInformation = selectCRMWhatsappInvoiceFromCRMShippingRankingViewResult.result;

          const shippingRankingData = selectCRMWhatsappInvoiceFromCRMShippingRankingViewResult.result;
          const colors = shippingRankingData.map((_, i) => `hsl(${(i * 360 / shippingRankingData.length)}, 70%, 50%)`);

          this.display.CRMShippingRankingInformation = {
            data: shippingRankingData,
            CRMWhatsappInvoiceCountChartOptions: {
              chart: { type: 'donut', height: '400px', width: '100%', toolbar: { show: false } },
              labels: shippingRankingData.map(item => item.CRMAgentName || 'No registrado'),
              colors: colors,
              legend: { show: false },
              title: { text: 'ORDENES POR AGENTE DE ENTREGA', align: 'center', style: { fontWeight: 'bold' } }
            },
            CRMWhatsappInvoiceCountChartSeries: shippingRankingData.map(item => item.CRMWhatsappInvoiceCount)
          };
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappInvoiceFromCRMShippingRankingView_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del ranking, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.selectCRMWhatsappInvoiceFromCRMShippingRankingView = false;       
      },


      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            if (this.systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMShippingRanking/CRMLocalityID')){
              let CRMLocalityIDPermissions = JSON.parse(this.systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMShippingRanking/CRMLocalityID').CRMAgentPermissionValue);
              if (CRMLocalityIDPermissions.length == 1) this.navigation.CRMLocalityID = CRMLocalityIDPermissions[0];
            }
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      setDefaultValues(){
        this.input.date = this.systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMShippingRanking/selectAllDate')?.CRMAgentPermissionValue == '1' ? Array.from({length: 60}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(59-i)); return d.toISOString().split('T')[0]; }) : Array.from({length: 45}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(44-i)); return d.toISOString().split('T')[0]; });
      },

    
    },

    async mounted(){
      await this.getSystemInformationData();
      this.setDefaultValues();
      this.selectCRMWhatsappInvoiceFromCRMShippingRankingView(true);
      this.interval.selectCRMWhatsappInvoiceFromCRMShippingRankingView = setInterval(() => {
        this.selectCRMWhatsappInvoiceFromCRMShippingRankingView(false);
      }, 20000);
    },

    beforeUnmount(){
      if (this.interval.selectCRMWhatsappInvoiceFromCRMShippingRankingView) clearInterval(this.interval.selectCRMWhatsappInvoiceFromCRMShippingRankingView);
      this.interval.selectCRMWhatsappInvoiceFromCRMShippingRankingView = null;
    }
  }
</script>